import { render, staticRenderFns } from "./ModifyDatasetForm.vue?vue&type=template&id=2cd412e4"
import script from "./ModifyDatasetForm.vue?vue&type=script&lang=js"
export * from "./ModifyDatasetForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports